import { createAction, props } from '@ngrx/store';
import { IStaticDataResponse } from '../models/static-data.model';

export const loadProductSubTypes = createAction('[StaticData] Load ProductSubTypes');

export const loadProductSubTypesSuccess = createAction(
  '[StaticData] Load ProductSubTypes Success',
  props<{ response: IStaticDataResponse[] }>()
);

export const loadProductSubTypesFailure = createAction('[StaticData] Load ProductSubTypes Failure', props<{ error: any }>());


export const loadProductSubTypesByType = createAction('[StaticData] Load ProductSubTypesByType',
  props<{ request: {typeId: string} }>()
);

export const loadProductSubTypesByTypeSuccess = createAction(
  '[StaticData] Load ProductSubTypesByType Success',
  props<{ response: IStaticDataResponse[] }>()
);

export const loadProductSubTypesByTypeFailure = createAction('[StaticData] Load ProductSubTypesByType Failure', props<{ error: any }>());